import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import { useEffect, useRef, useState } from "react";
import { IEmailTemplate } from "../../models/EmailTemplate";
import { IModel } from "./EmailTemplate";
import { Search } from "../../shared/Search";
import { Fetch } from "../../shared/Fetch";
import React from 'react';
import { EmptyEmailTemplate } from "./EmptyEmailTemplate";
import ReadMoreTableComponent from "./readMoreTableComponent";
import {ILogin, IPermissionProps } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";



interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IEmailTemplate>, loading: boolean });
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    // const [expand,setExpand]=useState(false);

    useEffect(() => {
        loadTableData();
    }, [globalFilter, props.reload]);
    const dt = useRef<any>(null);
    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Email_Template", "GET", null, `search=${globalFilter}`, props.toast);
        if (response) {

            const data: Array<IEmailTemplate> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyEmailTemplate });
    };
    const openEdit = (rowDatauser: IEmailTemplate) => {
        props.setModal({ open: true, singleData: rowDatauser });
        // console.log(rowDatauser)
    };

    const renderContent = (rowData: IEmailTemplate | any) => {
        const content = rowData.template_Body;
        if (content.length > 50) {
            let xy = content.substring(0, 50);
            let yz = content;
            return <ReadMoreTableComponent less={xy} more={yz} />
        } else {
            return content;
        }
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Email Template</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );

    // const handleReadMore = () => {
    //     setExpand(!expand);
    //   };

    // const render = (rowData: IEmailTemplate |any) => {
    //     const content = rowData.template_Body;
    //     if (content) {
    //         let xy=content.substring(0, 50);

    //     return (
    //         <>
    //         {expand ? <p>{rowData.template_Body}</p> : xy}
    //   <Link onClick={handleReadMore} to={""}>{expand ? 'Show Less' : 'Read More'}</Link>
    //   </>
    //     );
    //     };

    // };

        let _roles: Array<number> = [];
        const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
        loginObj.roles.forEach(role => {
            _roles.push(role.role_ID);
        });

    const actionBodyTemplate = (rowData: IEmailTemplate) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
            </div>
        );
    };

        const DateFormat = loginObj?.date_Format;


    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} ></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                ref={dt}
                value={tableData.tableData}
                emptyMessage="No Data found."
                header={header}
                loading={tableData.loading}
            >
                <Column field="template_Name" header="Template Name" />
                <Column field="template_Subject" header="Template Subject" />
                <Column field="template_Body" header="Template Body" body={renderContent} />
                {/* <Column field="created_At" header="Created At " /> */}
                <Column field="created_At" header = "created_At" body={(rowData: any) => safeFormatDate( rowData.created_At, "yyyy-MM-dd",  DateFormat )}/>
                <Column body={actionBodyTemplate} />
            </DataTable>
        </>
    );
}
